import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Social from "./components/Social";
import Nav from "./components/Nav";
import Home from "./components/Home";
import Bio from "./components/Bio";
import Tour from "./components/Tour";
import Press from "./components/Press";
import Music from "./components/Music";
import Video from "./components/Video";
import Gallery from "./components/Gallery";
import Posters from "./components/Posters";
import Photos from "./components/Photos";
import Buy from "./components/Buy";
import Contact from "./components/Contact";

import "./App.css";

const App = () => {
    return (
        <Router>
            <div className="App">
                <Route path="/" component={Social} />
                <Route path="/" component={Nav} />
                <Route exact path="/" component={Home} />
                <Route exact path="/bio" component={Bio} />
                <Route exact path="/tour" component={Tour} />
                <Route exact path="/press" component={Press} />
                <Route exact path="/music" component={Music} />
                <Route exact path="/video" component={Video} />
                <Route exact path="/gallery" component={Gallery} />
                <Route exact path="/gallery/posters" component={Posters} />
                <Route exact path="/gallery/photos" component={Photos} />
                <Route exact path="/contact" component={Contact} />
                <Route
                    exact
                    path="/buy"
                    component={props => (
                        <Buy
                            name="Keep On Movin'"
                            description="$17 LP + $6 USA Shipping & Handling"
                            amount="23"
                            {...props}
                        />
                    )}
                />
            </div>
        </Router>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js